export const urlPaths = {
	numberOfUnits: 'v0/myfleet/widget/unit',
	averageAgeOfEquipment: 'v0/myfleet/widget/equipment',
	countFinancedData: 'v0/myfleet/widget/ticf',
	myFleetList: 'v0/myfleet/fleetList',
	fleetListAEMHeaders: 'v0/myfleet/fleetListAEMHeaders',
	myfleetSearch: 'v0/myfleet/list',
	trucksToReview: 'v0/myfleet/trucks-to-review',
	aemFooterData: 'v0/aemfooter',
	equipmentData: 'v0/getEilTruck/',
	equipmentImage: 'v0/equipment/getEquipmentImage',
	myfleetDownload: 'v0/myfleet/download',
	equipmentTypes: 'v0/myfleet/filter/equipmentTypes',
	equipmentFinanceData: 'v0/getFinancials/',
	repairTypeData: 'v0/equipment/filter/repairTypes',
	saveUser: 'v0/user/saveUserData',
	registrationFormLabels: 'v0/aem-registration/complete-your-profile',
	startPageLabels: 'v0/aem-registration/registration-startpage',
	pendingUserRequest: 'v0/user/pending-user-list',
	UserMangementTableData: 'v0/user/users-list',
	userManagementListStatus: 'v0/user/status',
	getLatestUserStatus: 'v0/user/get-latest-user-status',
	getUserDetails: 'v0/user/user-info',
	getCompanyLocation: 'v0/user/company-location-list',
	equipmentLabels: 'v0/aemfleetpage/equipment-labels',
	moveTruck: 'v0/equipment/moveTruck',
	addMyFleetEquipmentTruck: 'v0/equipment/addTruck',
	userManagementAEMHeaders: 'v0/aem-user-management',
	dashboardDetails: 'v0/dashboard/equipment',
	notificationsList: 'v0/notification/list',
	deleteNotification: 'v0/notification/update-notification',
	updateNotificationList: 'v0/notification/mark-read',
	downloadUserList: 'v0/user/download-user-list',
	rejectUsers: 'v0/user/reject-users',
	approveUsers: 'v0/user/approve-bulk-user',
	loggedUser: 'v0/user/profile-details',
	loggedUserLocations: 'v0/user/profile-location-details',
	updateUserLocation: 'v0/user/update-locations',
	removeEquipment: 'v0/equipment/removeTruck',
	OrderManagementTableData: 'v0/order/list',
	serviceHistoryTable: 'v0/service-management/service-history/list',
	saveUserDetailsData: 'v0/user/update-user-details',
	getApproveScreenUserDetails: 'v0/user/approve-new-user/user-info',
	getPrefilledUserDetails: 'v0/v1/user/prefillUserDetails',
	userManagementRolesStatus: 'v0/user/role-list',
	downloadEquipmentOrderList: 'v0/order/download-order-list',
	orderDetails: 'v0/order/details',
	downloadServiceManagementServiceHistoryTableList: 'v0/service-management/download-service-history-table',
	serviceManagementEquipmentTypes: 'v0/service-management/service-history/filter',
	serviceOrderData: 'v0/service-management/service-order-details',
	assignedUsersData: 'v0/account/assigned-users-list',
	companyDetails: 'v0/user/company-details',
	removeCompanyLocation: 'v0/account/removeCompanyLocation',
	updatePrimaryLocation: 'v0/account/updatePrimaryLocation',
	downloadManualsInfo: 'v0/tips/download/blob/',
	locationDetails: 'v0/account/getLocationDetails',
	companyAssignedUsers: 'v0/account/company-profile-assigned-users-list',
	changeRequestList: 'v0/myfleet/change-request',
	aemTnCdata: 'v0/aem-registration/terms-and-conditions',
	submitTnC: 'v0/user/terms-and-conditions-submit',
	submitPolicy: 'v0/user/privacy-policy-submit',
	aemPolicyData: 'v0/aem-registration/privacy-policy',
	saveUserProfileDetails: 'v0/user/update-user-profile',
	addCompanyLocation: 'v0/account/add-new-company-location',
	unassignUsersData: 'v0/user/location-details/unassign-user',
	assignUsersData: 'v0/account/assign-user',
	corporateConvert: 'v0/dashboard/convert-to-corporate-account',
	adminLocationList: 'v0/v1/account-management/admin-location-list',
	switchAccount: 'v0/v1/account-management/switch-account',
	unreadNotificationsCount: 'v0/notification/list/allUnreadCount',
	getAddNewUser: 'v0/user/add-new-user',
	validateRemoveCompanyLocation: 'v0/account/validateRemoveCompanyLocation',
	verifyInformation: 'v0/v1/user/verify-information',
	saveGeneralUser: 'v0/v1/user/save-general-user',
	saveIndividualUser: 'v0/v1/user/save-individual-user',
	businessAccountRequestData: 'v0/v1/business-account/pending-ba-list',
	uploadNewLocationFile: 'v0/v1/user/upload-new-location?userId=',
	rejectBaUser: 'v0/v1/business-account/reject-ba-user',
	getAdditionalLocations: 'v0/v1/user/additional-locations',
	saveBusinessUser: 'v0/v1/user/save-business-user',
	submitAdditionalLocations: 'v0/v1/user/submit-business-user-req',
	connectedDeviceData: 'v0/equipment/getEquipTelematicsData',
	vehicleUtilization: 'v0/equipment/telematics-utilization',
	latestKeyHours: 'v0/myfleet/widget/key-hours',
	downloadLocationList: 'v0/v1/business-account/download-location-list/',
	uploadNewLocationFileReg: 'v0/v1/user/upload-ba-location-list',
	updateAdminDetails: 'v0/v1/business-account/update-user-admin-details',
	tmhCorporateAdminDetails: 'v0/v1/business-account/tmh-corp-admin-profile-details',
	businessRegistrationLocationDownload: 'v0/v1/user/business-admin-template/download',
	inviteUserLocationDownload: 'v0/v1/account-management/invite-users-template/download',
	inviteUserSubmit: 'v0/v1/account-management/upload-users',
	tmhCustomerSupportDetails: 'v0/v1/business-account/support-role-profile-details',
	approveBusinessAdmin: 'v0/v1/business-account/approve-business-admin',
	landingPageLabels: 'v0/v1/aem-landing-page',
	equipTelematicsVehicleData: 'v0/equipment/equipTelematicsVehicleData',
	gtsAddressConversionToCoordinates: 'v0/equipment/gtsAddressConversionToCoordinates',
	weeklyImpactDetectionWidget: 'v0/equipment/telematics-impact-data',
	lastTenErrorCodesDataList: 'v0/v1/equipment/equipTelematicsErrorDetailedData',
	equipmentQuotesTableEILData: 'v0/v2/myquotes/list',
	dealerDetails: 'v0/dashboard/search-dealer-by-zip',
	billingAddressList: 'v0/v2/myquotes/getBillingAddressForQuote',
	headerAlertBanner: 'v0/v1/aem-alert-banner',
	myQuotesListDownload: 'v0/v2/myquotes/download-quotes-list',
	myQuotesPdfDownload: 'v0/v2/myquotes/getQuoteDoc',
	quotepromoBanner: 'v0/v1/aemquotes/quote-content-block',
	myinsightsPromobanner: 'v0/v1/aeminsights/insight-content-block',
	myinsightsTable: 'v0/myinsights/list',
	myinsightsTableListDownload: 'v0/myinsights/download',
	shippingLocationList: 'v0/order/shipping-location-list',
	serviceManagementFilterList: 'v0/service-management/filters',
	equipmentOrderFilterList: 'v0/order/filters',
	triggerEmailToTmhCustomerSupport: 'v0/v1/user/registration-failure-email',
	updateLocationLabel: 'v0/account/update-location-info',
	domainListData: 'v0/domain/list',
	updateDomainDetails: 'v0/domain/update',
	assignDomainDetails: 'v0/domain/assign',
	downloadInvoicePdf: 'v0/service-management/service-history/download-invoice',
	startImpersonation: 'v0/user/start-impersonation',
	contactUsTicket: 'v0/create-ticket',
	validateImpersonation: 'v0/user/impersonation-user-details',
	customerSupportLabel: 'v0/v1/aem-customer-support-page',
	unassignedLocations: 'v0/account/getUnassignedLocations',
	accessLocationManagement: 'v0/account/allowLocationManagement',
	locationLabels: 'v0/v1/aem-location-access-management',
	serviceHistoryCount: 'v0/aem/get-service-history-count',
	contactUsLabel: 'v0/v1/aem-contact-us-page',
	verifyDomain: 'v0/domain/verify',
	zendeskToken: 'v0/auth/zendesk-token',
	contactForm: 'v0/contact-form-prefill',
	bulkUserInvite: 'v0/user/add-bulk-users',
	bulkUserTemplate: 'v0/user/add-users-template/download',
	equipmentOptions: 'v0/equipment/selectOptions',
	addBulkEquipment: 'v0/equipment/addBulkTruck',
	verifyEquipment: 'v0/equipment/verifyTruck',
	reportTruckIssue: 'v0/equipment/report-truck-issue',
	submituser: 'v0/account/update-users-location',
	addBulkEquipmentDownload: 'v0/equipment/download-template/?templateType=',
	addBulkEquipmentDownloadSingleLocation: 'v0/equipment/download-template/?locationId=',
	addBulkEquipmentUpload: 'v0/equipment/bulkEquipmentAdd',
	moveBulkEquipment: 'v0/equipment/bulkEquipmentMove',
	removeBulkEquipment: 'v0/equipment/bulkEquipmentRemove',
	getAddBulkLocationList: 'v0/account/available-location-to-add',
	addBulkLocationDownload: 'v0/v1/user/business-admin-template/download',
	addBulkLocationUpload: 'v0/account/add-new-locations',
	connectedWeeklyImpactDetectionPayload: 'v0/myinsights/widget/weekly-impact-data',
	dailyUsageWidget: 'v0/myinsights/widget/utilization-usage',
	latestConnectedKeyHours: 'v0/myinsights/widget/daily-hour-summary',
	dailyErrorSummary: 'v0/myinsights/widget/daily-error-summary',
	removeReminder: 'v0/user/user-preferences',
	reviewListDownload: 'v0/myfleet/review-list-download',
	cancelSubscriptionRenewal: 'v0/subscription/cancel-subscription',
	downloadSubscriptionReport: 'v0/subscription/request-status/',
	switchRole: 'v0/account/switch-profile',
	subscriptionPlanDetail: 'v0/subscription/plan-details',
	subscriptionAccountSummary: 'v0/subscription/account-summary',
	downloadAccountSummary: 'v0/subscription/download/account-summary',
	downloadAllSubscriptions: 'v0/subscription/download/subscriptions/all-subscription',
	downloadSubscriptionAddress: 'v0/subscription/download/subscriptions/subscription-address',
	subscriptionPaymentDetails: 'v0/subscription/payment-details',
	subscriptionList: 'v0/subscription/all-subscriptions',
	changeLanguage: 'v0/user/set-language'
};

export const jsonPaths = {
	userDetailsAemLabels: '/jsonData/userDetailsAemLabels.json',
	orderManagementHeaders: '/jsonData/orderManagementAemLabels.json',
	dashboardHeaders: '/jsonData/dashboardAEMLabels.json',
	myQuotesAemLabels: '/jsonData/myQuotesAemLabels.json',
	myInsightsTabAemLabels: '/jsonData/myInsightsTabAemLabels.json',
	inviteUsersAemLabels: '/jsonData/inviteUsersAEMLabels.json',
	equipmentOrderDetailHeaders: '/jsonData/orderDetailAemLabel.json',
	accountSettingsHeaders: '/jsonData/accountSettingsAEMLabels.json',
	removeEquipmentAemLabels: '/jsonData/removeEquipmentAEMLabels.json',
	addNewLocationHeaders: '/jsonData/addViewCompanyLocationsAEM.json',
	addMoveEquipmentLabel: '/jsonData/add-move-equipment-aem-label.json',
	addBulkEquipmentLabel: '/jsonData/add-bulk-equipment-aem-label.json',
	currentLocation: '/jsonData/currentLocation.json',
	confirmLeavePageLabels: '/jsonData/confirmLeavePageAEMLabels.json',
	addEquipmentDuplicateVINNumber: 'jsonData/addEquipmentDuplicateVINNumber.json',
	addEquipmentExistingVINNumber: 'jsonData/addEquipmentExistingVINNumber.json',
	addEquipmentSuccess: 'jsonData/addEquipmentSuccess.json',
	serviceOrderDetails: '/jsonData/serviceManagementiInvoiceDetailsAEMLabels.json',
	removeLocationModalsAEMLabels: '/jsonData/removeLocationModalsAEMLabels.json',
	addUserAemLabels: '/jsonData/addUserAemLabels.json',
	serviceMangementAemLabels: '/jsonData/serviceManagementAEMLabels.json',
	changeRequestTableAemlabels: '/jsonData/changeRequestTableAemlabels.json',
	reviewListTableAemLabels: '/jsonData/reviewListAEMLabels.json',
	notificationsPageLabel: '/jsonData/notificationsTabsAemLabel.json',
	pendingApprovalPageLabel: '/jsonData/confirmationPageLabels.json',
	businessAccountRequestAemLabel: '/jsonData/business-account-request-page-aem-labels.json',
	editAdminCompanyDetailsAemLabels: '/jsonData/editAdmin-Company-Details-AEMLabels.json',
	businessAccountSuccessRegistrationLabels: '/jsonData/businessAccountSuccessRegistrationLabels.json',
	businessRegistrationFlowSubmitModalLabels: '/jsonData/businessRegistrationFlowSubmitModalLabels.json',
	businessRegistrationDownloadModalLabels: '/jsonData/business_registration_upload_modal_labels.json',
	myInsightsAEMLabels: '/jsonData/myInsightsAEMLabels.json',
	addBulkLocationLabels: '/jsonData/add-bulk-location-aem-label.json',
	bulkLocationMockData: '/jsonData/add-bulk-location-mock-data.json',
	shellDataLabels: '/jsonData/shell-data-labels.json',
	subscriptionManagementAEMLabels: '/jsonData/subscriptionManagementAEMLabels.json'
};
